module.exports = __webpack_public_path__ + "img/img004.b33272e8.png";